import { render } from "./TeamHistory.vue?vue&type=template&id=79732fbf"
import script from "./TeamHistory.vue?vue&type=script&lang=js"
export * from "./TeamHistory.vue?vue&type=script&lang=js"
script.render = render

export default script